const HomeheaderImage = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8dHJhdmVsfGVufDB8fDB8fHww",
    head: "Explore The World Beyond Limits",
    description: "Discover breathtaking landscapes, hidden beaches, and unforgettable adventures across the globe. Your journey starts here."
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8dHJhdmVsfGVufDB8fDB8fHww",
    head: "Adventure Awaits You",
    description: "From mountain peaks to peaceful valleys, experience thrilling moments and create memories that last forever."
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8dHJhdmVsfGVufDB8fDB8fHww",
    head: "Find Your Perfect Escape",
    description: "Take a break from routine and travel to places where nature meets comfort and relaxation."
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjZ8fHRyYXZlbHxlbnwwfHwwfHx8MA%3D%3D",
    head: "Travel. Discover. Experience.",
    description: "Immerse yourself in vibrant cultures, scenic views, and unforgettable journeys tailored just for you."
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1512100356356-de1b84283e18?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzB8fHRyYXZlbHxlbnwwfHwwfHx8MA%3D%3D",
    head: "Create Memories Around The World",
    description: "Every destination has a story. Let us help you write yours with comfort, safety, and adventure."
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1612278675615-7b093b07772d?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDF8fHRyYXZlbHxlbnwwfHwwfHx8MA%3D%3D",
    head: "Discover Hidden Paradises",
    description: "Explore destinations that are off the beaten path and experience beauty beyond imagination."
  },
  {
    id: 7,
    image: "https://images.unsplash.com/photo-1498307833015-e7b400441eb8?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDV8fHRyYXZlbHxlbnwwfHwwfHx8MA%3D%3D",
    head: "Journey Into The Extraordinary",
    description: "Step out of your comfort zone and explore destinations that inspire, excite, and amaze."
  },
  {
    id: 8,
    image: "https://images.unsplash.com/photo-1511739001486-6bfe10ce785f?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8ODV8fHRyYXZlbHxlbnwwfHwwfHx8MA%3D%3D",
    head: "Your Dream Destination Awaits",
    description: "Plan your perfect vacation with curated tours, comfortable stays, and unforgettable experiences."
  },
  {
    id: 9,
    image: "https://images.unsplash.com/photo-1442570468985-f63ed5de9086?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTQxfHx0cmF2ZWx8ZW58MHx8MHx8fDA%3D",
    head: "Experience Nature Like Never Before",
    description: "Breathe fresh air, witness stunning sunsets, and reconnect with nature in the most beautiful locations."
  },
  {
    id: 10,
    image: "https://images.unsplash.com/photo-1499856871958-5b9627545d1a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTYwfHx0cmF2ZWx8ZW58MHx8MHx8fDA%3D",
    head: "Start Your Journey Today",
    description: "Adventure is calling. Pack your bags and let us guide you toward your next unforgettable destination."
  }
];

export default HomeheaderImage;